import { PaymentType } from "src/api";
import { usePaymentValidation } from "src/hooks";
import { _t } from "src/utils/translation";

interface UseDepositValidationParams {
  amount: string;
  paymentFeeError: string | null;
  paymentFee?: number;
}

export interface DepositErrors {
  inputErrors: string[];
  paymentFeeErrors: string[];
  paymentValidationErrors: string[];
}

export const useDepositValidation = (params: UseDepositValidationParams) => {
  const { amount, paymentFeeError, paymentFee } = params;

  const { paymentValidationErrors } = usePaymentValidation({
    amount: Number(amount),
    paymentType: PaymentType.Deposit,
    fee: paymentFee,
  });

  const errors: DepositErrors = {
    inputErrors: [
      ...(!amount ? [_t("VALIDATION.AMOUNT_SHOULD_NOT_BE_EMPTY")] : []),
      ...(Number(amount) <= 0 ? [_t("VALIDATION.AMOUNT_SHOULD_BE_GREATER_THAN_ZERO")] : []),
    ],
    paymentFeeErrors: paymentFeeError ? [_t("VALIDATION.ERROR_ESTIMATING_PAYMENT_FEE")] : [],
    paymentValidationErrors: paymentValidationErrors,
  };

  return {
    errors,
  };
};
